/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SetDefaultRequest {
    getFixupPrototypeFunction() { return SetDefaultRequest.fixupPrototype; }

    static newInstance(model: Partial<SetDefaultRequest>): SetDefaultRequest {
        let obj = Object.assign(new SetDefaultRequest(), model);
        SetDefaultRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SetDefaultRequest>): SetDefaultRequest {
        if (!model) return null;
        return SetDefaultRequest.newInstance(<SetDefaultRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SetDefaultRequest) {
        if (!obj) return;

        models.SetDefaultRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SetDefaultRequest): boolean {
        Object.setPrototypeOf(obj, SetDefaultRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Specify the monitoring_template_uri of the template to mark it as default
     */
    monitoring_template_uri: string;

}
